import React from "react";
import { Callout } from "../../../../Callout/Callout";
import { Hyperlink } from "../../../../Links/Hyperlink/Hyperlink";
import { Text } from "../../../../Text/Text";
import { TruncatedText } from "../../../../TruncatedText/TruncatedText";
import { FinalColumnProps } from "./props";

export const getFinalColumnContent = (props: FinalColumnProps, disabled: boolean | undefined): React.ReactNode => {
    switch (props.contentType) {
        case "hyperlink":
            return props.hyperlinkElements.map((element, index) => <Hyperlink {...element} disabled={disabled} key={index} />);
        case "text":
            return props.textElements.map((element, index) =>
                props.truncatedTextProps ? (
                    <TruncatedText
                        lines={props.truncatedTextProps.lines}
                        stopPropagation={props.truncatedTextProps.stopPropagation}
                        {...element}
                        disabled={disabled}
                        key={index}
                    />
                ) :
                <Text {...element} disabled={disabled} key={index} />
            );
        case "callout":
            return props.calloutElements.map((element, index) => <Callout {...element} key={index} />);
        default:
            return undefined;
    }
};
